import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthenticationService,private snackBar: MatSnackBar) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(error => {
             
            let errorMessage = 'Errore sconosciuto';

            // Estrai messaggio da error.error.message, se presente
            if (error.error) {
                if (typeof error.error === 'string') {
                    errorMessage = error.error;
                } else if (typeof error.error.error === 'string') {
                    errorMessage = error.error.error;
                }  
            }

            // Mostra lo Snackbar con il messaggio testuale
            this.snackBar.open(errorMessage, 'Chiudi', {
                duration: 5000,
                panelClass: ['error-snackbar']
            });

            // Logout se 401
            if (error.status === 401) {
                this.authenticationService.logout();
            }

            return throwError(() => new Error(errorMessage));
        }))
    }
}
